import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Input } from "reactstrap";
import { getDestination } from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd } from "react-icons/md";
import Pagination from "../../Components/Paginate";
import { CSVLink } from 'react-csv'
import { BiSolidFileExport } from "react-icons/bi";

const Destination = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: { destination, subSubCategoryCount },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [stateId, setStateId] = useState('');
  const [cityId, setCItyId] = useState('');
  const [categoryList, setcategoryList] = useState([]);
  const [sort, setSort] = useState('asc');
  const [paginate, setPaginate] = useState(40);
  const [categoryFilter, setCategoryFilter] = useState("");
  const [subCategoryFilter, setSubCategoryFilter] = useState("");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  useEffect(() => {
    axios.get(`/api/admin/v1/state-list`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    }).then((res) => {
      setcategoryList(
        res.data.stateLists?.map((item) => ({ state_name: item.state_name, id: item.id }))
      );
    }).catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (categoryFilter) {
      axios(`/api/admin/v1/get-city/${categoryFilter}`)
        .then(({ data }) => {
          setSubCategoryList(data?.data);
        }).catch((err) => console.error(err));
    } else {
      setSubCategoryList([]);
    }
  }, [categoryFilter]);

  useEffect(() => {
    dispatch(getDestination(auth?.token, paginate, page, search, stateId, cityId, sort));
  }, [auth?.token, paginate, page, search, stateId, cityId, sort,]);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ! ")) {
      axios.delete(`/api/admin/v1/destination/${id}`, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      }).then((res) => {
        toast.success(res.data.message);
        dispatch(getDestination(auth?.token));
      }).catch((err) => toast.error("Somthing Went Wrong"));
    }
  };

  const csvHead = [["state", "city", "town"]];
  const csvData = destination?.map((cv) => [
    cv?.state?.state_name,
    cv?.city?.city_name,
    cv?.town_name,
  ]);
  const exportData = csvHead.concat(csvData);

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white">Destination</h5>
            {allowedPermissions?.some?.(
              (item) =>
                item?.permission?.moduleType === "SUBSUBCATEGORIES" &&
                item?.permission?.permission === "create"
            ) && (
                <Link to="/add-destination">
                  <Button className="bg-white text-black" size="sm">
                    <span className="me-2"><MdAdd size={22} /></span>
                    Add Destination
                  </Button>
                </Link>
              )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }} >
        <div className="row">
          <div className="col-md-7 mb-2">
            <div className="row">
              <div className="col-md-4">
                <Input size={"sm"} value={search} placeholder="Search By Name" onChange={(({ target: { value } }) => setSearch(value))} />
              </div>
              <div className="col-md-4">
                <Input size={"sm"} type="select" name="category" value={categoryFilter} onChange={(({ target }) => {setCategoryFilter(target.value);setStateId(target.value);})}>
                  <option value="">Select State</option>
                  {categoryList?.map?.((item) => {
                    return (
                      <option value={item.id} key={item.id}>{item?.state_name}</option>
                    );
                  })}
                </Input>
              </div>
              {/* <div className="col-md-4">
                <Input size={"sm"} type="select" name="category" value={subCategoryFilter} onChange={(({ target }) => setSubCategoryFilter(target.value))}>
                  <option value="">Select City</option>
                  {subCategoryList?.map?.((item) => {
                    return (
                      <option value={item.id} key={item.id}>{item?.city_name}</option>
                    );
                  })}
                </Input>
              </div> */}
            </div>
          </div>
          <div className={`col-md-2 ${allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "SUBSUBCATEGORIES" &&
              item?.permission?.permission === "export"
          ) ? "offset-md-2" : "offset-md-3"}`}>
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "SUBSUBCATEGORIES" &&
              item?.permission?.permission === "export"
          ) && (
              <div className="col-md-1 mb-2">
                <CSVLink filename={"sub-sub-categories.csv"} className="text-black ms-3"
                  title="Export To CSV" data={exportData}>
                  <BiSolidFileExport size={25} />
                </CSVLink>
              </div>
            )}
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>State</th>
                  <th> City</th>
                  <th>Town Name</th>
                  {allowedPermissions?.some?.(
                    (item) =>
                      item?.permission?.moduleType === "SUBSUBCATEGORIES" &&
                      (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")
                  ) && (
                      <th>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {destination?.length === 0 ? (
                  <tr>
                    <td colSpan="12">No data found</td>
                  </tr>
                ) : (<>
                  {destination?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1 + page * paginate}</th>
                        <td>{item?.state_name}</td>
                        <td>{item?.cityCount}</td>
                        <td>{item?.townCount}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "SUBSUBCATEGORIES" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/update-destination/${item?.state_id}`}>
                                  <AiOutlineEdit size={22} className="text-warning me-3" />
                                </Link>
                              )}

                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "SUBSUBCATEGORIES" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete size={22} className="text-danger" onClick={() => handleDel(item.id)} />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input type="select" id="paginate" onChange={e =>
                setPaginate(
                  e.target.value
                )
              } value={paginate} className="paging custom-select custom-select-page m-0">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {subSubCategoryCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, subSubCategoryCount)} of {subSubCategoryCount} entries
                </>
              ) : (
                <>Showing 0 to 0 of 0 entries</>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination pageCount={(subSubCategoryCount) / paginate} onChange={(e) => setPage(e.selected)} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Destination;
